// Global UI configuration
export default {
  // Default toast duration in milliseconds
  toastDurationMs: 5000,
  // Default toast position: 'right' | 'left' | 'center'
  toastPosition: 'right',
  // Auto logout timeout in minutes (set to 0 to disable)
  autoLogoutTimeoutMinutes: 10,
  // Warning time before logout in minutes
  logoutWarningMinutes: 2,
  // Enable 2FA OTP after login (true/false) - social login is always exempt
  enable2FALogin: false,
};


